"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logError = exports.logRender = void 0;
const logRenderStyle = 'color: #050; background-color: #eee;padding: 2px 6px;border-radius: 3px';
class Component {
}
const logRender = (inst, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
params) => {
    if (process.env.NODE_ENV !== 'production' &&
        process.env.NODE_ENV !== 'test') {
        let name;
        switch (typeof inst) {
            case 'function':
                name = inst.name;
                break;
            case 'object':
                name = inst.constructor.name;
                break;
            default:
                name = inst;
                break;
        }
        // tslint:disable:no-console
        if (params) {
            console.debug('%c<' + name + ' />', logRenderStyle, params);
        }
        else {
            console.debug('%c<' + name + ' />', logRenderStyle);
        }
        // tslint:enable:no-console
    }
};
exports.logRender = logRender;
// tslint:disable-next-line: no-any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const logError = (...args) => {
    if (process.env.NODE_ENV !== 'production') {
        // tslint:disable-next-line:no-console
        console.error(...args);
    }
};
exports.logError = logError;
//# sourceMappingURL=log.utils.js.map